import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { debounce, get, noop } from 'lodash';
import { List } from 'immutable';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import { Element } from 'react-scroll';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Print from '@material-ui/icons/Print';
import Refresh from '@material-ui/icons/Refresh';
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown';
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp';

import immutableToJS from 'helpers/immutableToJS';
import {
  dispatchRestMaker,
  getNextSortOptions,
  getSortIcon,
  scrollTo,
} from 'helpers/utils';
import { isMobile } from 'helpers/detect-mobile';
import {
  HighlightText,
  injectIntl,
  InvoiceBadge,
  PrintPreviewDialog,
  SearchComponent,
  Toggle,
  Tooltip,
} from 'components';
import {
  updateProfile,
} from 'redux/auth/actions';
import goodActions from 'redux/goods/actions';
import marketPlaceActions from 'redux/marketPlace/actions';
import { storeNotificationsSelector } from 'redux/notifications/selectors';
import {
  getRequestingSelector,
  selectState,
} from 'redux/selectors';
import sellersActions, { sellersMarkAsReadActions, sellersAcceptActions } from 'redux/sellers/actions';
import storeActions, { marketPlaceProductsActions } from 'redux/storeItems/actions';

import {
  CardBioContent,
  CardCover,
  CardLogo,
} from 'components/Card';
import StoreCardDetails from './StoreCardDetails';
import StoreCardPrint from './StoreCardPrint';

const styles = () => ({
  cardAction: {
    borderRadius: '50% !important;',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;',
    marginTop: 0,
  },
  notAvailablecardAction: {
    boxShadow: 'initial !important;',
    marginTop: 0,
  },
  cardHeader: { width: '100%', paddingRight: 0 },
  cardHeaderRoot: { paddingTop: '5px', paddingBottom:'5px' },
  cardHeaderWarehouse: {
    backgroundColor: '#aaaaaa',
    paddingRight: 0,
    width: '100%',
  },
  cardMedia: { position: 'relative' },
  cardTitle: { height: 70 },
  icon: { color: 'grey' },
});

class StoreCard extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isFarmer: PropTypes.bool,
    readOnly: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    contact: PropTypes.shape({}),
    expanded: PropTypes.bool,
    goods: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    goodsRequesting: PropTypes.bool.isRequired,
    imageEditable: PropTypes.bool,
    info: PropTypes.shape({}),
    initialExpand: PropTypes.bool,
    isCatalog: PropTypes.bool,
    isMarketPlace: PropTypes.bool,
    marketPlaceRequesting: PropTypes.bool.isRequired,
    notifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    searchText: PropTypes.string,
    sellerRequesting: PropTypes.bool.isRequired,
    sellersAcceptRequesting: PropTypes.bool.isRequired,
    storeItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    storeItemsRequesting: PropTypes.bool.isRequired,
    tokenInfoRequesting: PropTypes.bool,

    createSeller: PropTypes.func,
    createSellersAccept: PropTypes.func.isRequired,
    createSellersMarkAsReadItem: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    listGoodItems: PropTypes.func,
    listMarketPlaceProducts: PropTypes.func,
    listStoreItems: PropTypes.func,
    readContact: PropTypes.func,
    readMarketPlace: PropTypes.func,
    setExpanded: PropTypes.func,
    showNotifications: PropTypes.func,
    updateProfile: PropTypes.func.isRequired,
    isAllowedToUpdate: PropTypes.bool,
    isRetailPage: PropTypes.bool,
  };

  static defaultProps = {
    contact: {},
    expanded: false,
    imageEditable: false,
    info: [],
    initialExpand: false,
    isCatalog: false,
    isMarketPlace: false,
    searchText: '',
    tokenInfoRequesting: false,

    createSeller: noop,
    listGoodItems: noop,
    listMarketPlaceProducts: noop,
    listStoreItems: noop,
    readContact: noop,
    readMarketPlace: noop,
    setExpanded: noop,
    showNotifications: noop,
    isAllowedToUpdate: true,
    isRetailPage: false,
  };

  state = {
    farmMode: false,
    printDlgOpen: false,
    printHeaderChecked: [],
    searchTextInItem: '',
    sortOptions: [],
    profileIsOff: false,
  };

  componentWillMount() {
    const { initialExpand, isRetailPage } = this.props;
    const { isFarmer } = this.context;
    const { printHeaderChecked } = this.state;
    if (initialExpand) this.handleExpandChange(true);
    if (isFarmer) {
      printHeaderChecked.push(true, true, true, true, true, true, true, true, true, true, true);
    } else {
      printHeaderChecked.push(
        true, true, true, true, true, true, true, true, true, true, true, true,
      );
    }

    const { currentUser } = this.context;
    const { profile } = currentUser.account;
    if (profile) {
      this.setState({ profileIsOff: !isRetailPage ? profile.isOff : profile.isConsumerOff !== undefined ? profile.isConsumerOff : true });
    }
  }


  onCancelSearch = () => this.setState({ searchTextInItem: '' });

  onPrintClose = () => this.setState({ printDlgOpen: false });

  onPrintOpen = () => {
    this.setState({ printDlgOpen: true });
    this.reloadStore();
  }

  onSearchText = value => this.setState({ searchTextInItem: value });

  onSortTimeStamp = () => {
    this.setState({
      sortOptions: getNextSortOptions(this.state.sortOptions, 'timestamp'),
    });
  }

  onSortAlert = () => {
    this.setState({
      sortOptions: getNextSortOptions(this.state.sortOptions, 'alert'),
    });
  }

  acceptSeller = () => {
    const { createSellersAccept, readMarketPlace, info } = this.props;
    const { currentUser } = this.context;
    createSellersAccept(info.contact.sellerId, {
      onSuccess: () => {
        readMarketPlace(info.id, { accountId: get(currentUser, 'accountId'), tab: 'farm' });
      },
    });
  }

  createSeller = () => {
    const { createSeller, info, readMarketPlace } = this.props;
    const { currentUser } = this.context;
    createSeller({
      email: info.email,
      onSuccess: () => {
        readMarketPlace(info.id, { accountId: get(currentUser, 'accountId'), tab: 'farm' });
      },
    });
  }

  handleExpandChange = () => {
    const expanded = !this.props.expanded;
    const { info, setExpanded } = this.props;
    setExpanded(expanded ? info.id : -1, () => {
      if (!expanded) return;
  
      this.reloadStore();
      setTimeout(() => scrollTo(`store-${info.id}`), 500);
    });
  };

  markAsRead = () => {
    const { contact, createSellersMarkAsReadItem } = this.props;
    createSellersMarkAsReadItem(contact.sellerId, {
      onSuccess: () => {
        this.reloadStore();
      },
    });
  }

  reloadStore = () => {
    const {
      contact,
      info,
      isCatalog,
      isMarketPlace,
      listGoodItems,
      listMarketPlaceProducts,
      listStoreItems,
      readContact,
      isRetailPage,
    } = this.props;
    const { isFarmer } = this.context;
    const { farmMode } = this.state;
    if (isMarketPlace) {
      listMarketPlaceProducts({ farmId: info.id });
    } else if (isFarmer) {
      listStoreItems({ isConsumer: isRetailPage });
    } else {
      if (!isCatalog) readContact(info.id);
      if (farmMode && !isCatalog) {
        listStoreItems({ farmId: contact.sellerId, isConsumer: isRetailPage });
      } else {
        listGoodItems({ sellerAccountId: isCatalog ? null : info.id });
      }
    }
  }

  updateCheckState = (isChecked, index) => {
    const { printHeaderChecked } = this.state;
    printHeaderChecked[index] = isChecked;
    this.setState({ printHeaderChecked: printHeaderChecked.slice() });
  }

  toggleForFarmMode = farmMode =>
    this.setState({ farmMode }, this.reloadStore);

  toggleIsOff = (isInputChecked) => {
    const { updateProfile, isRetailPage } = this.props;
    const { profileIsOff } = this.state;
    this.setState({ profileIsOff: !profileIsOff });
    if (!isRetailPage) {
      updateProfile({ isOff: !isInputChecked,
        // noDispatch: true,
        onSuccess: (data) => {
          this.toggleOnSuccess(data);
        },
      });
    } else {
      updateProfile({ isConsumerOff: !isInputChecked,
        onSuccess: (data) => {
          this.toggleOnSuccess(data);
        },
      });
    }
  };

  toggleOnSuccess = (data) => {
    if (!data || !data.user) {
      const { currentUser } = this.context;
      const { isRetailPage } = this.props;
      const { profile } = currentUser.account;
      this.setState({ profileIsOff: !isRetailPage ? profile.isOff : profile.isConsumerOff });
    }
  }

  render() {
    const { currentUser, isFarmer, readOnly } = this.context;
    const {
      classes,
      contact,
      expanded,
      formatMessage,
      goods,
      goodsRequesting,
      imageEditable,
      info,
      isCatalog,
      searchText,
      storeItems,
      storeItemsRequesting,
      notifications,
      isMarketPlace,
      marketPlaceRequesting,
      sellerRequesting,
      sellersAcceptRequesting,
      showNotifications,
      tokenInfoRequesting,
      isAllowedToUpdate,
      isRetailPage,
      updateProfile,
    } = this.props;
    const {
      farmMode,
      printDlgOpen,
      printHeaderChecked,
      sortOptions,
      searchTextInItem,
    } = this.state;
    const iconDirectionForAlertOrder = getSortIcon(sortOptions, 'alert');
    const iconDirectionForTimestampOrder = getSortIcon(sortOptions, 'timestamp');
    const logoUrl = info.id ? info.logoUrl || '' : currentUser.account.profile.logoUrl;
    const coverImageUrl = info.id ? info.coverImageUrl || '' : currentUser.account.profile.coverImageUrl;
    const accountId = get(currentUser, 'accountId');
    const subTitle = (
      <div className="sub-title">
        <div className="sub-title-first">
          <div className="email">
            <HighlightText
              highlight={searchText}
              text={info.id ? info.email : currentUser.account.email}
            />
          </div>
        </div>
      </div>
    );
    const avatar = (
      <CardLogo
        image={logoUrl}
        imageEditable={imageEditable}
        info={info.id ? info : currentUser.account.profile}
      />
    );

    const details = farmMode || isFarmer || isMarketPlace ? storeItems : goods;
    const loading = farmMode || isFarmer || isMarketPlace ? storeItemsRequesting : goodsRequesting;
    const isWarehouse = !info.companyName;
    const printPreviewMsg = isWarehouse ? 'Warehouse' : (isCatalog ? 'Catalog' : 'Availability List');
    const storeCardPrint = (
      <div className="group-tool-print d-sm-up-block">
        { isRetailPage && (<span style={{ fontWeight: '600' }}>{formatMessage('PRINT: Direct to Consumer')}</span>)}
        <Tooltip tooltip={formatMessage('Print')}>
          <IconButton
            onClick={this.onPrintOpen}
            style={{ padding: 5 }}
          >
            { isRetailPage ? (<Print style={{ color: '#1e88e5' }} />) : (<Print />)}
          </IconButton>
        </Tooltip>
        <PrintPreviewDialog
          onClose={this.onPrintClose}
          open={printDlgOpen}
          title={`${formatMessage('Print Preview')} - ${formatMessage(printPreviewMsg)}`}
        >
          <StoreCardPrint
            checkUpdated={this.updateCheckState}
            currentUser={currentUser}
            details={details}
            formatMessage={formatMessage}
            info={info}
            isFarm={farmMode || isFarmer}
            isCatalog={isCatalog}
            isWarehouse={isWarehouse}
            isMarketPlace={isMarketPlace}
            printHeaderChecked={printHeaderChecked}
            sortOptions={sortOptions}
          />
        </PrintPreviewDialog>
      </div>
    );
    const { profile } = currentUser.account;
    const { profileIsOff } = this.state;
    const notAvailable = contact.isDeleted || get(contact, 'sellerProfile.isOff');
    const isMe = contact.requestorId === contact.buyerId;

    const cardCover = coverImageUrl ? (
      <CardMedia
        classes={{ root: classes.cardMedia }}
        image={coverImageUrl}
      >
        <CardCover
          image={coverImageUrl}
          imageEditable={imageEditable}
          info={info}
        />
      </CardMedia>
    ) : (
      <CardCover
        image={coverImageUrl}
        imageEditable={imageEditable}
        info={info}
      />
    );

    const storeOpenMessage = isMobile ? formatMessage('Open') : !isRetailPage ? formatMessage('Storefront is OPEN') : formatMessage('Retail Shop is OPEN');
    const storeCloseMessage = isMobile ? formatMessage('Closed') : !isRetailPage ? formatMessage('Storefront is CLOSED') : formatMessage('Retail Shop is CLOSED');
    return (
      <Element
        name={`store-${info.id}`}
        style={{ padding: '1px 0' }}
      >
        <Card>
          <CardHeader
            action={
              notAvailable ? (
                <div style={{ width: '50px' }}>&nbsp;</div>
              ) : (
                <IconButton
                  aria-expanded={expanded}
                  aria-label={formatMessage('Show more')}
                  onClick={this.handleExpandChange}
                >
                  {expanded ? <CollapseIcon /> : <ExpandIcon />}
                </IconButton>
              )}
            avatar={avatar}
            classes={{
              action: notAvailable ? classes.notAvailablecardAction : classes.cardAction,
              content: classes.cardHeader,
              root: classes.cardHeaderRoot,
            }}
            subheader={subTitle}
            style={notAvailable ? { backgroundColor: '#e4e5e6' } : {}}
            title={
              <div className="store-card-title">
                <div className="store-card-sub-title">
                  <div>
                    <HighlightText
                      highlight={searchText}
                      text={info.companyName ? info.companyName : formatMessage('Warehouse')}
                      style={info.companyName ? {} : {
                        color: '#ff6e0f',
                        fontSize: 20,
                        }
                      }
                    />
                  </div>
                  {(!info.companyName) && (
                    <div className="store-card-full-name">
                      <HighlightText
                        highlight={searchText}
                        style={{
                          color: info.id ? 'gray' : '#ff6e0f',
                          fontSize: 12,
                        }}
                        text={info.companyName ? get(info, 'companyName') : get(profile, 'companyName')}
                      />
                    </div>
                  )}
                </div>
                <div className="vendor-sub-header">
                  {contact.isDeleted && isMe && (
                    <InvoiceBadge type="deactivated">
                      {formatMessage('Blocked')}
                    </InvoiceBadge>
                  )}
                  {contact.isDeleted && !isMe && (
                    <InvoiceBadge type="deactivated">
                      <div className="d-sm-down-none">
                        {formatMessage('Vendor Disabled Your Ordering')}
                      </div>
                      <div className="d-md-up-none">
                        {formatMessage('Disabled')}
                      </div>
                    </InvoiceBadge>
                  )}
                  {!isFarmer && storeCardPrint}
                  {get(contact, 'sellerProfile.isOff') && (!contact.isDeleted) ? (
                    <InvoiceBadge type="deactivated">
                      <div className="d-sm-down-none">
                        {formatMessage('Vendor Is Closed')}
                      </div>
                      <div className="d-md-up-none">
                        {formatMessage('Closed')}
                      </div>
                    </InvoiceBadge>
                  ) : (
                    <div>
                      {!contact.isDeleted && !get(contact, 'sellerProfile.isOff') && info.companyName && !isMarketPlace && !isCatalog && !isFarmer && (
                        <InvoiceBadge type="activated">
                          <div className="d-sm-down-none">
                            {formatMessage('Open')}
                          </div>
                          <div className="d-md-up-none">
                            {formatMessage('Open')}
                          </div>
                        </InvoiceBadge>
                      )}
                    </div>
                  )}
                  <div style={{ width: '40px' }}>
                    {(!isMarketPlace && !isCatalog && !isFarmer && notifications.length > 0) ?
                      <Tooltip tooltip={formatMessage('Farmer Update')}>
                        <span>
                          <Button
                            mini
                            onClick={() => showNotifications(info, notifications)}
                            style={{
                              backgroundColor: '#ff602e',
                              // marginTop: 5,
                              transform: 'scale(0.8)',
                            }}
                            variant="fab"
                          >
                            <div style={{ color: 'white' }}>
                              {notifications.length}
                            </div>
                          </Button>
                        </span>
                      </Tooltip>
                      : ''
                    }
                  </div>
                </div>
                {(isCatalog || isFarmer) &&
                  (
                    <div className="catalog-sub-header">
                      <Toggle
                        label={
                          isFarmer ?
                          (profileIsOff ? storeCloseMessage : storeOpenMessage)
                          : (profileIsOff ? formatMessage('Closed to Buyers') : formatMessage('Open'))
                        }
                        onToggle={(e, isInputChecked) =>
                          this.toggleIsOff(isInputChecked)}
                        title={profileIsOff ? formatMessage('Deactivated') : formatMessage('Open')}
                        toggled={!profileIsOff}
                        disabled={isAllowedToUpdate ? tokenInfoRequesting : true}
                      />
                      <IconButton
                        className="catalog-reload d-md-down-none"
                        onClick={this.reloadStore}
                      >
                        <Refresh />
                      </IconButton>
                    </div>
                  )
                }
              </div>
            }
          />
       
          <Collapse
            in={expanded && !contact.requestorId}
            timeout="auto"
            unmountOnExit
          >
            <CardContent style={{ padding: 0 }}>
              <div className={`group-tool-bar ${!isMarketPlace ? 'hide' : ''}`}>
                <SearchComponent
                  cancelSearch={this.onCancelSearch}
                  disabled={readOnly}
                  placeholder={isCatalog ? formatMessage('Items or Vendor') : formatMessage('Items')}
                  search={debounce(this.onSearchText, 500)}
                  searchText={searchText}
                />
                <div className="group-tool-other">
                  <div className="second-part">
                    {isMarketPlace && !accountId && (
                      <Link to="/">
                        <Button
                          color="primary"
                          disabled={readOnly}
                        >
                          {`${formatMessage('Connect with')} ${info.companyName}`}
                        </Button>
                      </Link>
                    )}
                    {isMarketPlace && accountId && !isFarmer && !info.contact && (
                      <Button
                        color="primary"
                        disabled={readOnly || sellerRequesting || marketPlaceRequesting}
                        onClick={this.createSeller}
                        variant="contained"
                      >
                        {`${formatMessage('Connect with')} ${info.companyName}`}
                      </Button>
                    )}
                    {isMarketPlace && accountId && !isFarmer &&
                    info.contact && !info.contact.requestorId && (
                      <Button
                        color="primary"
                        disabled
                        variant="contained"
                      >
                        {formatMessage('Connected')}
                      </Button>
                    )}
                    {isMarketPlace && accountId && !isFarmer && info.contact &&
                    info.contact.requestorId && info.contact.requestorId === accountId && (
                      <Button
                        color="primary"
                        disabled
                        variant="contained"
                      >
                        {formatMessage('Connect Request Sent')}
                      </Button>
                    )}
                    {isMarketPlace && accountId && !isFarmer && info.contact &&
                    info.contact.requestorId && info.contact.requestorId !== accountId && (
                      <Button
                        color="primary"
                        disabled={readOnly || sellersAcceptRequesting || marketPlaceRequesting}
                        onClick={this.acceptSeller}
                        variant="contained"
                      >
                        {formatMessage('Accept Connect Request')}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <StoreCardDetails
                isMobile={isMobile}
                currentUser={currentUser}
                details={details}
                farmMode={farmMode}
                iconDirectionForAlertOrder={iconDirectionForAlertOrder}
                iconDirectionForTimestampOrder={iconDirectionForTimestampOrder}
                info={info}
                isCatalog={isCatalog}
                isFarm={farmMode || isFarmer}
                isMarketPlace={isMarketPlace}
                isWarehouse={isWarehouse}
                onSortAlert={this.onSortAlert}
                onSortTimeStamp={this.onSortTimeStamp}
                readOnly={(!isFarmer || isMarketPlace) && Boolean(info.id)}
                readOnlyForPermission={readOnly}
                reloadStore={this.reloadStore}
                requesting={loading}
                searchText={searchTextInItem}
                sortOptions={sortOptions}
                storeCardPrint={storeCardPrint}
                toggleForFarmMode={this.toggleForFarmMode}
                isAllowedToUpdate={isAllowedToUpdate}
                isRetailPage={isRetailPage}
                updateProfile={updateProfile}
              />
            </CardContent>
          </Collapse>
        </Card>
      </Element>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = (state, props) => ({
  ...selectState('goods', 'goods')(state, 'goods'),
  ...selectState('marketPlace', 'marketPlace')(state, 'marketPlace'),
  ...selectState('sellers', 'seller')(state, 'seller'),
  ...selectState('sellers', 'sellersAccept')(state, 'sellersAccept'),
  ...selectState('storeItems', 'storeItems')(state, 'storeItems'),
  notifications: (!props.isFarm && props.contact && props.contact.sellerId) ?
    storeNotificationsSelector(props.contact.sellerId)(state) : List(),
  tokenInfoRequesting: getRequestingSelector('auth', 'tokenInfo')(state),
});

export default compose(
  setDisplayName('StoreCard'),
  connect(
    mapStateToProps,
    dispatch => ({
      ...dispatchRestMaker([
        [storeActions, 'storeItem'],
        [marketPlaceProductsActions, 'marketPlaceProduct'],
        [goodActions, 'goodItem'],
        [sellersActions, 'seller'],
        [sellersMarkAsReadActions, 'sellersMarkAsReadItem'],
        [sellersAcceptActions, 'sellersAccept'],
        [marketPlaceActions, 'marketPlace'],
        [updateProfile, 'updateProfile'],
      ])(dispatch),
      updateProfile: payload => dispatch(updateProfile(payload)),
    }),
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(StoreCard);
